import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ReferentialType } from '@app/core/models/referentials/referential-type.model';
import { ReferentialsModel } from '@app/core/models/referentials/referentials.model';
import { ReferentialService } from '@app/core/services/referential.service';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ReferentialResolver  {
  constructor(private referentialService: ReferentialService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<ReferentialsModel> {
    const referentialsTypes: ReferentialType[] = route.data.referentialsTypes;
    return forkJoin(
      referentialsTypes.includes(ReferentialType.ASSETTYPES)
        ? this.referentialService.getAssetTypes()
        : of([]),
      referentialsTypes.includes(ReferentialType.GROUPTYPES)
        ? this.referentialService.getGroupTypes()
        : of([]),
      referentialsTypes.includes(ReferentialType.PROFESSIONTYPES)
        ? this.referentialService.getProfessionTypes()
        : of([]),
      referentialsTypes.includes(ReferentialType.RECYCLINGFLAGS)
        ? this.referentialService.getRecyclingFlags()
        : of([]),
      referentialsTypes.includes(ReferentialType.WAITINGFLAGS)
        ? this.referentialService.getWaitingFlags()
        : of([]),
      referentialsTypes.includes(ReferentialType.REJECTIONFLAGS)
        ? this.referentialService.getRejectionFlags()
        : of([]),
      referentialsTypes.includes(ReferentialType.EMAILTEMPLATETYPES)
        ? this.referentialService.getEmailTemplateTypes()
        : of([]),
      referentialsTypes.includes(ReferentialType.VAT)
        ? this.referentialService.getVatRef()
        : of([]),
      referentialsTypes.includes(ReferentialType.EXPENSEFAMILYTYPE)
        ? this.referentialService.getExpenseFamilyTypes()
        : of([]),
      referentialsTypes.includes(ReferentialType.INVOICEPPRTYPE)
        ? this.referentialService.getInvoicePPRTypes()
        : of([]),
      referentialsTypes.includes(ReferentialType.DEDUCTIONTYPE)
        ? this.referentialService.getDeductionType()
        : of({}),
      referentialsTypes.includes(ReferentialType.TYPOLOGIE)
        ? this.referentialService.getTypologieTypes()
        : of({}),
      referentialsTypes.includes(ReferentialType.COMPANY)
        ? this.referentialService.getCompany()
        : of({}),
      referentialsTypes.includes(ReferentialType.TREELEVEL)
        ? this.referentialService.getTreeLevel()
        : of({}),
      referentialsTypes.includes(ReferentialType.EXPENSETRADETYPE)
        ? this.referentialService.getExpenseTradeTypes()
        : of({}),
    ).pipe(
      map(
        (data: any) =>
          new ReferentialsModel(
            data[0],
            data[1],
            data[2],
            data[3],
            data[4],
            data[5],
            data[6],
            data[7],
            data[8],
            data[9],
            data[10],
            data[11],
            data[12],
            data[13],
            data[14],
          )
      )
    );
  }
}
